import instance from ".";
import { API_ENDPOINTS } from "../utils/constants";

export const getHistory = async (startDate, endDate) => {
    const responses = await instance.get(API_ENDPOINTS.sales.history, {
        params: {
            startDate,
            endDate,
        },
    });
    return responses;
};

export const getReceipt = async (sid) => {
    const response = await instance.get(API_ENDPOINTS.sales.receipt, {
        params: {
            sid
        }
    })
    return response;
}